// extracted by mini-css-extract-plugin
module.exports = {"container":"AmountAndCount_container__pCamb","count":"AmountAndCount_count__1As5f","amount":"AmountAndCount_amount__YYOsQ","divider":"AmountAndCount_divider__3kCBK"};